<div class="h-50 p-4 overflow-auto rounded-2xl bg-card outline-solid outline-primary outline-0 border"
  [class.outline-4]="isDragOver" [class.cursor-pointer]="!control.disabled" [class.border-red-500]="!control.disabled && control.touched && control.errors" [host]="this" dropFile>

  <!-- field label -->
  <ng-container *transloco="let t">
    @if (caption !== undefined && caption !== null) {
      <mat-label>{{ caption }}</mat-label>
    }
  </ng-container>

  <!-- image container with actions -->
  <div class="z-10 w-fill inset-0 flex flex-col p-4 relative">

    <!-- image container -->
    <div (click)="inputClick(fileInput)" class="flex flex-col w-full items-center justify-center relative">

      <!-- image from url -->
      @if (isImage && imageUrl && !base64) {
        <img class="max-h-28 aspect-auto w-auto" [src]="imageUrl">
      }

      <!-- image from base 64 -->
      @if (isImage && base64) {
        <img class="max-h-28 aspect-auto w-auto" [src]="base64">
      }

      <!-- default icon if no image is present -->
      @if (!isImage || (!base64 && !imageUrl)) {
        <mat-icon class="icon-size-14 text-hint"
        [svgIcon]="'heroicons_solid:document-plus'"></mat-icon>
      }

      <!-- image type text -->
      @if (type) {
        <div
          class="absolute left-0 bottom-0 px-1.5 rounded text-sm font-semibold leading-5 text-white bg-black"
          [class.bg-red-600]="type === 'pdf'" [class.bg-blue-600]="type === 'doc'"
          [class.bg-green-600]="type === 'xls'" [class.bg-gray-600]="type === 'txt'"
          [class.bg-amber-600]="type === 'jpg' || type === 'jpeg' || type === 'png'">
          {{type.toUpperCase()}}
        </div>
      }
    </div>
    <!-- action buttons -->
    <ng-container *transloco="let t">

      <!-- preview image -->
      @if (isImage) {
        <button mat-icon-button class="absolute top-24 right-0 m-4" (click)="previewFile($event)"
          matTooltip="{{'previewFile' | transloco}}">
          <mat-icon class="icon-size-5" svgIcon="heroicons_solid:eye"></mat-icon>
        </button>
      }

      <!-- remove image -->
      @if (base64 || imageUrl) {
        <button mat-icon-button class="absolute top-0 right-0 m-4"
          (click)="removeFile($event)" [matTooltip]="t('removeFile')" [disabled]="control.disabled">
          <mat-icon class="icon-size-5" [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
        </button>
      }

      <!-- download image -->
      @if (base64 || imageUrl) {
        <button mat-icon-button class="absolute top-12 right-0 m-4"
          (click)="downloadFile($event)" [matTooltip]="t('downloadFile')">
          <mat-icon class="icon-size-5" [svgIcon]="'mat_outline:download'" ></mat-icon>
        </button>
      }
    </ng-container>
  </div>

  <!-- bottom text -->
  <div class="flex flex-col flex-auto justify-center text-center text-sm font-medium">
    <ng-container *transloco="let t">

      <!-- file name -->
      @if (filename) {
        <div class="truncate" [matTooltip]="filename">{{ filename }}</div>
      }

      <!-- 'choose a file' text -->
      <div class="truncate" [matTooltip]="t('chooseOrDropAFile')">{{ t('chooseOrDropAFile')}}</div>

      <!-- accepted extensions -->
      @if (acceptedExtensions.length > 0) {
        <div class="text-secondary truncate">
          {{ t('acceptedExtensions', { extensions: acceptedExtensions.join(', ') }) }}
        </div>
      }
    </ng-container>
  </div>

  <!-- file input -->
  <input class="hidden" #fileInput (change)="onFileSelected($event)" type="file" [disabled]="control.disabled" />

  <!-- progress bar -->
  @if (loading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
</div>